import React from "react";
import { styled } from "styled-components";
import { Draggable } from "react-beautiful-dnd";

const Container = styled.div`
border: 1px solid lightgrey;
border-radius: 5px;
padding: 8px;
margin-bottom: 8px;
background: ${props => ( props.matchclass === 'match' ? 'lightgreen' : '#be0c0c' )}
`;

export default class Step extends React.Component {

	render() {

		console.log('props.matchclass', this.props.matchclass);

		return (
			<Draggable
			  draggableId={this.props.step.id}
			  index={this.props.index}
			>
				{(provided, snapshot) => (
					<Container
					  className={this.props.matchclass}
					  id={this.props.step.id}
					  ref={provided.innerRef}
					  {...provided.draggableProps}
					  {...provided.dragHandleProps}
					  isDragging={snapshot.isDragging}
					>
						{this.props.index + 1}.  {this.props.step.content}
					</Container>
				)}
			</Draggable>
		)
	}
}
